import Img from './Img';
import { getOddDesc } from './Odd';
import useBetslip from './useBetslip';

export default function Odd(props) {
    const odd = props.data;
    const [addBet, selected] = useBetslip(odd);

    const desc = props.desc || getOddDesc(odd, props.noHandicap);

    let classList = '';
    if (selected) {
        classList = ' active';
    } else if (odd.value == null) {
        classList = ' disabled';
    }

    return (
        <div className={"c_22" + classList} onClick={addBet} data-agg-id={odd.betData.aggId} data-bet-id={odd.betData.id} data-odd-id={odd.id}>
            <div className="c_22_1">{desc}</div>
            {odd.value == null ?
                <Img className="c_22_2" src="icon_caution_my_account.svg" height="16px" width="16px" />
                :
                <div className="c_22_2">{odd.value}</div>
            }
        </div>
    );
}